import { addError } from '@shared/utils/logger';
import { getConfig } from '../../../config/config';

const { locationServiceUri, locationServiceApiKey } = getConfig();

const logError = (message: string, details: unknown) => {
  addError(`[Geocoding] ${message}`, {
    details
  });
};

type GeocodingResult = Readonly<{
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
  };
  formatted_address: string;
  place_id: string;
}>;

type GeocodingResponse = {
  results: GeocodingResult[];
  status: string;
  error_message?: string;
};

interface GeocodeOptions {
  address?: string;
  components?: string;
  bounds?: string;
  language?: string;
  region?: string;
}

export const geocodeAddress = async (options: GeocodeOptions): Promise<GeocodingResult | null> => {
  const _geocodeAddress = async (): Promise<GeocodingResponse | null> => {
    const params = { ...options, key: locationServiceApiKey };

    const searchParams = new URLSearchParams(params);
    const url = `${locationServiceUri}/geocode/json?${searchParams}`;

    const response = await fetch(url);

    if (!response.ok) {
      logError('Geocoding failed', { error: response.statusText, options });
      return null;
    }

    const data = await response.json();

    return data;
  };

  try {
    const result = await _geocodeAddress();

    if (result?.status === 'OK' && result?.results?.length > 0) {
      return result.results[0];
    }

    if (result?.error_message) {
      logError('Geocoding failed', { error: result.error_message, options });
    }

    return null;
  } catch (error) {
    logError('Failed to geocode', { error, options });
    return null;
  }
};
